<script>
import { BREAKPOINT_SWITCH } from '../utils/Breakpoints.js';
import StoreLocatorLarge from './StoreLocatorLarge.vue';
import StoreLocatorSmall from './StoreLocatorSmall.vue';

export default {
  name: 'StoreLocator',
  props: {
    stores: {
      type: Array,
      required: true,
    },
    defaultMapPosition: {
      type: Object,
      required: true,
    },
    defaultMapBounds: {
      type: Array,
      required: true,
    },
    pageTitle: {
      type: Array,
      required: true,
    },
  },
  computed: {
    /**
     * @return {boolean}
     */
    isLargeDevice() {
      return this.$matchMedia[BREAKPOINT_SWITCH];
    },
  },
  render(h) {
    return h(this.isLargeDevice ? StoreLocatorLarge : StoreLocatorSmall, {
      props: {
        stores: this.stores,
        pageTitle: this.pageTitle[0],
        defaultMapPosition: this.defaultMapPosition,
        defaultMapBounds: this.defaultMapBounds,
      },
    });
  },
};
</script>
